module.exports = __webpack_public_path__ + "img/2622.a9dbd862.jpg";